import React from 'react';
type FacebookProps = {
	pageUrl?: string;
	type?: string;
	title?: string;
	description?: string;
	image?: string;
	appID?: string;
};

const Facebook: React.FC<FacebookProps> = ({
	pageUrl,
	type,
	title,
	description,
	image,
	appID
}) => (
	<>
		{pageUrl && <meta property="og:url" content={pageUrl} />}
		{type && <meta property="og:type" content={type} />}
		{title && <meta property="og:title" content={title} />}
		{description && <meta property="og:description" content={description} />}
		{image && <meta property="og:image" content={image} />}
		{appID && <meta property="fb:app_id" content={appID} />}
	</>
);
export default Facebook;
